import React, { useEffect, useState } from "react";
import { Collapse, Form, Switch } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { authUserData } from "../../utils/Helper";

const NewPermissionPanelStep = ({
  appLabel,
  modelName,
  permissions,
  setState,
  state,
  index
}) => {
  const { t } = useTranslation();
  const { Panel } = Collapse;
  const [selectAll, setSelectAll] = useState(false);
  const [permissionDatas, setPermissionDatas] = useState(permissions);

  
  useEffect(() => {
    if (permissions) {
      const updatedPermissions = permissions.map(permission => {
        let model_name = permission.model_name.toLowerCase();
        let name = permission.codename;

        let mergeName = `${model_name}|${name}`

        let check = authUserData()?.group_permission?.includes(mergeName);
        

        return {
          ...permission,
        is_checked: state.permission.includes(permission.permission_id),
        is_disable: check
      }
      }
    );
      setPermissionDatas(updatedPermissions);
    } 
  }, [permissions, state.permission, modelName]);

const handleSelectAllChange = (checked) => {
    setSelectAll(checked);
    const updatedPermissionData = permissionDatas.map(permission => ({
      ...permission,
      is_checked: checked
    }));
    setPermissionDatas(updatedPermissionData);

    const selectedPermissions = updatedPermissionData
      .filter(permission => permission.is_checked)
      .map(permission => permission.permission_id);

    setState(prevState => ({
      ...prevState,
      permission: checked
        ? [...new Set([...prevState.permission, ...selectedPermissions])]
        : prevState.permission.filter(id => !updatedPermissionData.some(permission => permission.permission_id === id))
    }));
  };
  const handleSwitchChange = (checked, permissionId, isDisable) => {
    // if(isDisable){
      const updatedPermissionData = permissionDatas.map(permission => {
        if (permission.permission_id === permissionId) {
          return { ...permission, is_checked: checked };
        }
        return permission;
      });
      setPermissionDatas(updatedPermissionData);
  
      if (checked) {
        setState(prevState => ({
          ...prevState,
          permission: [...prevState.permission, permissionId]
        }));
      } else {
        setState(prevState => ({
          ...prevState,
          permission: prevState.permission.filter(id => id !== permissionId)
        }));
      }
    // }
    
  };

  useEffect(() => {
    const allChecked = permissionDatas.every(permission => permission.is_checked);
    setSelectAll(allChecked);
  }, [permissionDatas]);

  // useEffect(() => {
  //   setPermissionDatas(permissions);
  // }, [permissions]);

  function formatModelName(modelName) {
    return modelName
      .split('_') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');                   
  }

 
  return (
    <Collapse defaultActiveKey={[""]}>
      <Panel
        key={index}
        header={
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            {formatModelName(modelName)}
            <div style={{ display: "flex", alignItems: "center", marginRight: "30px" }}>
             
              <div onClick={(e) => e.stopPropagation()}>
                <Switch 
                  checked={selectAll} onChange={handleSelectAllChange} 
                  disabled={permissionDatas.some(permission => permission.is_disable)} 
                  // disabled={permission.is_disable || false}
                  />
              </div>
              <span style={{ marginLeft: 10, fontWeight: "600" }}>Select All</span>
            </div>
          </div>
        }
      >
        {permissionDatas.map(permission => {
          return (
          <div key={permission.permission_id} className="permissionlist TextFeild">
          
            <Form.Item className="radioitem">
            <div onClick={(e) => e.stopPropagation()}>

              <Switch
                checked={permission.is_checked}
                onChange={(checked) => handleSwitchChange(checked, permission.permission_id, permission.is_disable)}
                // disabled={permission.is_disable}
                disabled={permission.is_disable || false}
              />
              </div>
            </Form.Item>
            {permission.name}
          </div>
        )})}
      </Panel>
    </Collapse>
  );
};

NewPermissionPanelStep.propTypes = {
  modelName: PropTypes.string.isRequired,
  permissions: PropTypes.array.isRequired,
  setState: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  appLabel: PropTypes.number.isRequired,
  index: PropTypes.number
};

export default NewPermissionPanelStep;
